<template>
  <div class="row" style="height:400px;width:100%;">
    <div class="col-md">
      <div role="toolbar" class="btn-toolbar justify-content-between mb-2">
        <button @click="save()" class="btn btn-secondary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
        <div class="input-group ml-3">
          <input type="text" placeholder="Auftrags-Nr" class="form-control" v-model="testid"/>
          <div class="input-group-append">
            <button class="btn btn-secondary"><font-awesome-icon icon="vial"/></button>
          </div>
        </div>
      </div>
      <AceEditor ref="editor" :editorId='"addcartrule"' :lang="'javascript'" :content="script"/>
    </div>
    <div class="col-md">
      <iframe style="width:100%;height:500px;border: none;" :src="baseurl + 'help/scriptrules/cartupdate.html'">
      </iframe>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import rules from '@/modules/rules.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'RuleAddCart',
  components: {
    AceEditor
  },
  data() {
    return {
      script: "",
      testid: '',
      baseurl: config.baseUrl
    }
  },
  created: function() {
    var self = this;
    rules.load('updateCartCheck',function(data) {
      console.log(data);
      self.script = data.script;
    });
  },
  methods: {
    save: function() {
      this.script = this.$refs.editor.getContent();
      var update = {ruleId: 'updateCartCheck',script: this.script};
      var self = this;
      rules.save(update,function() {
        self.$bvToast.toast(`Regel gespeichert`, { title: 'Update Cart', autoHideDelay: 2000, appendToast: true, variant:'success' })
      });
    }
  }
}
</script>
